var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--decline",attrs:{"disabled":_vm.disabled,"type":_vm.type,"data-cy":_vm.commonCy.SINGLE_ORDER.MANAGE_ORDER.BUTTON__DECLINE},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" "+_vm._s(_vm.isPrimary ? 'Decline Order' : 'Decline')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }